import React from 'react';
import { Card, Alert, Table } from 'react-bootstrap';

const DiagnosticCartes = ({ cartes }) => {
  console.log('=== DIAGNOSTIC COMPLET ===');
  console.log('Nombre de cartes:', cartes?.length || 0);
  console.log('Cartes complètes:', JSON.stringify(cartes, null, 2));

  if (!cartes || cartes.length === 0) {
    return (
      <Card className="mb-4" bg="danger" text="white">
        <Card.Header>
          <h5>🚨 PROBLÈME : Aucune carte reçue</h5>
        </Card.Header>
        <Card.Body>
          <Alert variant="light">
            Les cartes ne sont pas chargées. Vérifiez que vous avez généré les cartes.
          </Alert>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="mb-4" bg="info" text="white">
      <Card.Header>
        <h5>🔍 DIAGNOSTIC DES CARTES ({cartes.length} cartes)</h5>
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover variant="light">
          <thead>
            <tr>
              <th>#</th>
              <th>Structure</th>
              <th>Agent ?</th>
              <th>Nom</th>
              <th>Prénoms</th>
              <th>Matricule</th>
              <th>Fonction</th>
              <th>Photo</th>
            </tr>
          </thead>
          <tbody>
            {cartes.map((carte, index) => {
              const hasAgent = !!carte.agent;
              const agent = carte.agent || {};
              
              return (
                <tr key={index} className={!hasAgent ? 'table-danger' : ''}>
                  <td>{index + 1}</td>
                  <td>
                    <small>
                      <pre style={{ margin: 0, fontSize: '10px' }}>
                        {JSON.stringify(Object.keys(carte), null, 2)}
                      </pre>
                    </small>
                  </td>
                  <td>{hasAgent ? '✅' : '❌'}</td>
                  <td>{agent.nom || '❌ MANQUANT'}</td>
                  <td>{agent.prenoms || '❌ MANQUANT'}</td>
                  <td>{agent.matricule || '❌ MANQUANT'}</td>
                  <td>{agent.fonction || '❌ MANQUANT'}</td>
                  <td>{agent.photoPath ? '✅' : '❌'}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Alert variant="light" className="mt-3">
          <strong>Première carte complète :</strong>
          <pre style={{ fontSize: '11px', maxHeight: '300px', overflow: 'auto' }}>
            {JSON.stringify(cartes[0], null, 2)}
          </pre>
        </Alert>
      </Card.Body>
    </Card>
  );
};

export default DiagnosticCartes;
